export default "__VITE_ASSET__DEME4vjI__"